import { render, staticRenderFns } from "./QuestionValueList.vue?vue&type=template&id=0c7c7fa0&scoped=true&"
import script from "./QuestionValueList.vue?vue&type=script&lang=ts&"
export * from "./QuestionValueList.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionValueList.vue?vue&type=style&index=0&id=0c7c7fa0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c7fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7c7fa0')) {
      api.createRecord('0c7c7fa0', component.options)
    } else {
      api.reload('0c7c7fa0', component.options)
    }
    module.hot.accept("./QuestionValueList.vue?vue&type=template&id=0c7c7fa0&scoped=true&", function () {
      api.rerender('0c7c7fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/questionValue/QuestionValueList.vue"
export default component.exports